export default "__VITE_ASSET__DLzo$GRZ__"